// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingDetails_root__dP1fp","rootItem":"BookingDetails_rootItem__Fgi8C"};